/*
  The shared mark path set, verbatim from the <g id="brand-mark"> every supplied SVG in
  resources/ embeds (docs/decisions/brand-assets.md §2): a triangle over a vertical stem
  with a crossbar and two legs, a stylised "4" over "A". Geometry spans x 0..84 and
  y 10..166 before the stroke; round caps and joins add half the stroke width.

  Never recolour the mark through anything but `currentColor` and never stretch it
  (brief §2.7.3). scripts/icons.mjs holds the same five paths for rasterising.
*/
export const MARK_PATHS = [
  'M 0 58 L 42 10 L 84 58 Z',
  'M 20 95 L 64 95',
  'M 42 58 L 42 136',
  'M 42 136 L 14 166',
  'M 42 136 L 70 166',
] as const

export const MARK_WIDTH = 84
export const MARK_HEIGHT = 156
export const MARK_TOP = 10

/** A viewBox that fits the mark drawn at `strokeWidth`, caps included. */
export function markViewBox(strokeWidth: number): string {
  const half = strokeWidth / 2
  return `${-half} ${MARK_TOP - half} ${MARK_WIDTH + strokeWidth} ${MARK_HEIGHT + strokeWidth}`
}
